import {
  GCPBillingFilters,
  GCPBillingListQuery,
  GCPBillingPagination,
} from './types';

export const buildGCPBillingQuery = (
  filters: GCPBillingFilters,
  pagination: GCPBillingPagination
): GCPBillingListQuery => {
  const query: GCPBillingListQuery = {
    page: pagination.page,
    per_page: pagination.perPage,
  };
  const billingId = filters.gcpBillingId.trim();

  if (filters.month) query.month = filters.month;
  if (billingId) query.gcp_billing_id = billingId;
  if (filters.currencies.length) {
    query.currency = filters.currencies.join(',');
  }
  if (filters.invoiceFilter !== 'all') {
    query.un_invoiced_only = filters.invoiceFilter === 'not-created';
  }
  if (filters.companyFilter !== 'all') {
    query.company_not_found_only = filters.companyFilter === 'not-found';
  }

  return query;
};
